import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-result-page">
      <div className="payment-result-container">
        <div className="cancel-animation">
          <div className="cancel-icon">✕</div>
        </div>
        
        <h1>Payment Cancelled</h1>
        <p className="cancel-message">
          No worries! You can support us anytime.
        </p>
        
        <div className="cancel-details">
          <p>Your payment was cancelled and you were not charged.</p>
          <p>Feel free to continue using ForceSight - it's completely free!</p>
        </div>

        <div className="cancel-actions">
          <button 
            className="primary-button"
            onClick={() => navigate('/dashboard')}
          >
            Return to Dashboard
          </button>
          <button 
            className="secondary-button"
            onClick={() => navigate('/')}
          >
            Go Home
          </button>
        </div>
      </div>

      <style jsx>{`
        .payment-result-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: var(--space-gradient);
        }

        .payment-result-container {
          background: rgba(0, 0, 0, 0.8);
          border: 2px solid var(--jedi-blue);
          border-radius: 16px;
          padding: 3rem;
          max-width: 500px;
          width: 100%;
          text-align: center;
          box-shadow: 0 20px 40px rgba(0, 102, 204, 0.3);
        }

        .cancel-animation {
          margin-bottom: 2rem;
        }

        .cancel-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto;
          background: var(--droid-gold);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
          color: white;
          animation: fadeIn 0.5s ease-out;
          box-shadow: 0 0 30px rgba(255, 183, 0, 0.4);
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        h1 {
          color: var(--force-cyan);
          font-family: var(--font-display);
          font-size: 2.5rem;
          margin: 1rem 0;
          animation: fadeInUp 0.6s ease-out 0.2s both;
        }

        .cancel-message {
          color: var(--droid-gold);
          font-size: 1.2rem;
          margin: 1rem 0;
          font-weight: bold;
          animation: fadeInUp 0.6s ease-out 0.3s both;
        }

        .cancel-details {
          margin: 2rem 0;
          animation: fadeInUp 0.6s ease-out 0.4s both;
        }

        .cancel-details p {
          color: var(--gray-300);
          margin: 0.5rem 0;
          line-height: 1.6;
        }

        .cancel-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          margin-top: 2rem;
          animation: fadeInUp 0.6s ease-out 0.5s both;
        }

        .primary-button {
          background: var(--jedi-blue);
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .primary-button:hover {
          background: var(--force-cyan);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 212, 255, 0.4);
        }

        .secondary-button {
          background: transparent;
          color: var(--force-cyan);
          border: 2px solid var(--force-cyan);
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .secondary-button:hover {
          background: rgba(0, 212, 255, 0.1);
          transform: translateY(-2px);
        }

        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 640px) {
          .payment-result-container {
            padding: 2rem;
          }

          h1 {
            font-size: 2rem;
          }

          .cancel-actions {
            flex-direction: column;
          }

          .primary-button,
          .secondary-button {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentCancelled;